import { T } from '@tribeplatform/react-components/i18n'
import { useModerationSettings } from '@tribeplatform/react-sdk/hooks'

import { LoadingIndicator } from '../../Site/Space/LoadingIndicator.js'
import { AgedBasedModeration } from '../AgedBasedModeration.js'

export function AgedBasedModerationRouter() {
  const { data: moderationSettings } = useModerationSettings({
    fields: 'all',
  })

  if (!moderationSettings) {
    return <LoadingIndicator />
  }

  return <AgedBasedModeration moderationSettings={moderationSettings} />
}

export function AgedBasedModerationBreadCrumb() {
  return <T id="Moderation.AgeBased" defaultMessage="Age-Based Moderation" />
}
